(function () {
  'use strict';

  angular.module('app.studentImpactReport')
    .controller('StudentImpactReportController', [
      'APP_CONSTANTS',
      'SessionService',
      'ngDialog',
      'toaster',
      'OrganizationInfoService',
      'FileSaver',
      '$state',
      '$scope',
      StudentImpactReportController
    ]);

  function StudentImpactReportController(
    APP_CONSTANTS,
    SessionService,
    ngDialog,
    toaster,
    OrganizationInfoService,
    FileSaver,
    $state,
    $scope,
  ) {
    const vm = this;
    const user = SessionService.getUser();

    if (!user.roles.isOrganizationManager
      && !user.roles.isAccountManager
    ) {
      $state.go('app.ownerdashboard');
      return;
    }

    vm.loading = {};
    vm.reports = [];
    vm.dtOptions = {
      order: [],
      columnDefs: [
        {
          orderable: false,
          targets: [1, 2]
        }
      ]
    };

    fetchStudentImpactReports();

    function fetchStudentImpactReports() {
      vm.loading.reports = true;
      OrganizationInfoService.fetchStudentImpactReports(user.sponsoredOrganizationId).then(
        function (response) {
          vm.reports = _.get(response, 'data.data') || [];
          vm.loading.reports = false;
        },
        function (error) {
          vm.loading.reports = false;
          toaster.pop('error', error.data.error.message || error.statusText);
        }
      );
    }

    function setReportBusy(report, isBusy) {
      if ($scope.$$phase) {
        report.busy = isBusy;
        return;
      }

      $scope.$applyAsync(function () {
        report.busy = isBusy;
      });
    }

    vm.download = function (report = {}) {
      report = report || {};

      const reportFileName = String(report.file || '').trim();

      if (!reportFileName) {
        toaster.pop('error', 'Error downloading the file');
        return;
      }

      let fileName = reportFileName.split('/').pop();

      try {
        fileName = decodeURIComponent(fileName);
      } catch (e) {
      }

      setReportBusy(report, true);

      OrganizationInfoService
        .downloadStudentImpactReport(user.sponsoredOrganizationId, reportFileName)
        .then(function (response) {
          const disposition = response.headers('content-disposition') || '';
          const matched = disposition.match(/filename\*?=(?:UTF-8''|\")?([^\";]+)/i);
          let headerFileName = matched && matched[1] ? matched[1] : '';
          if (headerFileName) {
            try {
              headerFileName = decodeURIComponent(headerFileName);
            } catch (e) {
            }
          }
          const finalFileName = headerFileName || fileName;
          const blob = new Blob([response.data], {
            type: response.headers('content-type') || 'application/octet-stream'
          });

          FileSaver.saveAs(blob, finalFileName);
        })
        .catch(function (error) {
          console.error('Error downloading the file', error);
          toaster.pop('error', 'Error downloading the file');
        })
        .finally(function () {
          setReportBusy(report, false);
        });
    };
  }
})();
